import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'

const Link = styled(RouterLink)`
  ${({ theme }) => theme.Typography.Link}
`

export { Link }
